import { combineReducers } from "@reduxjs/toolkit";

import persistReducer from "redux-persist/es/persistReducer";
import localStorage from "redux-persist/lib/storage";
import storage from "redux-persist/lib/storage/session";

import allOrder from "./AllOrder";
import cartData from "./CartData";
import customizedData from "./CustomizedData";
import mealData from "./MealData";
import filterData from "./FilterData";
import variationData from "./Variation";
import categoryItem from "./categoryItem";
import categoryData from "./categoryList";
import commonData from "./common";
import addressData from "./delivery";
import store from "./store";
import userData from "./userData";
import languageData from "./TransalationData";
import promotions from './promotions'

import checkoutAddress from './CheckoutAddress'
import AddonsData from "./AddonsData";
const authPersistConfig = {
  key: "session",
  storage: storage,
  blacklist: ["somethingTemporary"],
};
const authPersistConfigLocal = {
  key: "local",
  storage: localStorage,
  blacklist: ["somethingTemporary"],
};
const appReducer = combineReducers({
  store,
  categoryData: persistReducer(authPersistConfig, categoryData),
  checkoutAddress: persistReducer(authPersistConfig, checkoutAddress),
  categoryItem: persistReducer(authPersistConfig, categoryItem),
  languageData: persistReducer(authPersistConfig, languageData),
  cartData,
  variationData,
  customizedData,
  mealData,
  userData: persistReducer(authPersistConfigLocal, userData),
  addressData,
  allOrder,
  commonData,
  filterData,
  AddonsData,
  promotions
});

const rootReducer = (state: any, action: any) => {
  if (action.type === 'RESET_APP') {
    state = undefined; 
  }
  if (action.type === 'RESET_STORE_SELECTION') {
    const preservedState = {
      userData: state?.userData,
      store: state?.store,
    };
    state = preservedState;
  }
  return appReducer(state, action);
};


export default rootReducer;
